import { DrawerLink, UserTypes } from "./universal/divine-constants";
import { EventOutlined, PermMediaOutlined, PersonOutline, TipsAndUpdatesOutlined } from "@mui/icons-material";

export const Links: DrawerLink[] = [
	{name: "Users", path: "/users", icon: <PersonOutline />, access: [UserTypes.ADMIN]},
	{name: "Events", path: "/events", icon: <EventOutlined />, access: [UserTypes.ADMIN]},
	{name: "Kavithai Pictures", path: "/kavithai-pictures", icon: <PermMediaOutlined />, access: [UserTypes.ADMIN, UserTypes.MOD]},
	{name: "Cooking Tips", path: "/cooking-tips", icon: <TipsAndUpdatesOutlined />, access: [UserTypes.ADMIN, UserTypes.MOD]}
];